import { render } from "./DashboardProductos.vue?vue&type=template&id=6cd60545&scoped=true"
import script from "./DashboardProductos.vue?vue&type=script&lang=js"
export * from "./DashboardProductos.vue?vue&type=script&lang=js"

import "./DashboardProductos.vue?vue&type=style&index=0&id=6cd60545&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd60545"]])

export default __exports__